import { ModelConfig } from '@rematch/core';
import { CarrierWeightPricing } from '../../../models/entities/admin/carrierWeightPricing';
import { CarrierPricingResponse } from '../../../models/entities/admin/carrierPricingResponse';
import { localSDK as client } from '../../../sdk';
import { RootState } from '../../store/store';

export type CarrierWeightPricingType = {
    carrierWeightPricing: CarrierWeightPricing[];
    carrierPricingResponse?: CarrierPricingResponse;
    seletedCarrierCode?: string;
};

export const carrierWeightPricing: ModelConfig<CarrierWeightPricingType> = {
    state: {
        carrierWeightPricing: [],
        carrierPricingResponse: undefined,
        seletedCarrierCode: undefined
    },
    reducers: {
        setCarrierWeightPricing(state: CarrierWeightPricingType, carrierWeightPricing: CarrierWeightPricing[]): CarrierWeightPricingType {
            return { ...state, carrierWeightPricing };
        },
        setCarrierPricingResponse(state: CarrierWeightPricingType, carrierPricingResponse: CarrierPricingResponse): CarrierWeightPricingType {
            return { ...state, carrierPricingResponse };
        },
        setSelectedCarrierCode(state: CarrierWeightPricingType, carrierCode: string): CarrierWeightPricingType {
            return { ...state, seletedCarrierCode: carrierCode };
        }
    },
    effects: (dispatch: any) => ({
        async fetchCarrierWeightPricing(carrierCode: string) {
            const carrierWeightPricing = await client.carrierWeightPricing().fetchCarrierWeightPricing(carrierCode);
            dispatch.carrierWeightPricing.setCarrierWeightPricing(carrierWeightPricing);
        },
        async fetchPublicCarrierWeightPricingWithDimensions(payload: { 
            weight: number; 
            quantity: number; 
            regionId: number; 
            length?: number; 
            width?: number; 
            height?: number; 
        }) {
            const carrierPricingResponse = await client.carrierWeightPricing().fetchPublicCarrierWeightPricingWithDimensions(
                payload.weight, 
                payload.quantity, 
                payload.regionId, 
                payload.length, 
                payload.width, 
                payload.height
            );
            dispatch.carrierWeightPricing.setCarrierPricingResponse(carrierPricingResponse);
            return carrierPricingResponse;
        },
        async updateCarrierWeightPricing(
            {
                carrierWeightPricing
            }: {
                carrierWeightPricing: CarrierWeightPricing[];
            },
            rootState: RootState
        ) {
            await client.carrierWeightPricing().updateCarrierWeightPricing(carrierWeightPricing);
            dispatch.carrierWeightPricing.fetchCarrierWeightPricing(rootState.carrierWeightPricing.seletedCarrierCode);
        }
    }),
};
